<template>
  <form
    class="new-user box is-centered"
    @submit.prevent="onSubmit"
  >
    <h1 class="title is-4 has-text-primary">
      Actualizar Datos.
    </h1>

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="name"
          name="name"
          label="Nombre"
          left-icon="person"
          placeholder="Some Else"
          :value="name"
          :disabled="isLoading"
          required
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="companyName"
          name="name"
          label="Razón social:"
          left-icon="label"
          placeholder="Machete SA de CV"
          :value="companyName"
          :disabled="isLoading"
          required
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="tradeName"
          name="tradeName"
          label="Nombre Comercial:"
          left-icon="label"
          placeholder="Machete"
          :value="tradeName"
          :disabled="isLoading"
          required
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>
      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="employerRegistration"
          name="employerRegistration"
          label="Registro Patronal:"
          left-icon="label"
          placeholder="00000012340"
          :value="employerRegistration"
          :disabled="isLoading"
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputRfc
          :value="rfc"
          :disabled="isLoading"
          :valid-icon="false"
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputEmail
          :value="email"
          :disabled="isLoading"
          required
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="accountNumber"
          name="accountNumber"
          label="Número de cuenta:"
          left-icon="label"
          placeholder="00152356"
          :value="accountNumber"
          :disabled="isLoading"
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>
      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppSelectField
          id="projectName"
          name="projectName"
          label="Proyecto:"
          placeholder="Selecciona una opción"
          :value="projectName"
          :disabled="isLoading"
          :options="projectOptions"
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppSelectField
          id="multiUser"
          name="multiUser"
          label="Multi usuario:"
          placeholder="Selecciona una opción"
          :value="multiUser"
          :disabled="isLoading"
          :options="multiUserOptions"
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputPhoneNumber
          :value="phoneNumber"
          :disabled="isLoading"
          :valid-icon="false"
          @input="onChange"
          @change="onChange"
        />
      </div>
    </div>

    <ButtonSubmit
      :is-loading="isLoading"
      text="Actualizar Datos"
    />
  </form>
</template>

<script>
import upperFirst from 'lodash/upperFirst';
import { mapState, mapMutations, mapActions } from 'vuex';

import AppInputField from '@/components/AppInputField.vue';
import AppInputPhoneNumber from '@/components/AppInputPhoneNumber.vue';
import AppSelectField from '@/components/AppSelectField.vue';

const arrayToOptions = array => array.map(
  ({ value }) => ({
    value,
    label: value,
  }),
);

const projectArr = [
  { value: 'Negocios Empresarial', label: 'Negocios Empresarial' },
  { value: 'Negocios TP', label: 'Negocios TP' },
];

const multiUserArr = [
  { value: 'HABILITADO', label: 'HABILITADO' },
  { value: 'DESHABILITADO', label: 'DESHABILITADO' },
];

export default {
  name: 'UpdateUser',
  components: {
    AppInputField,
    AppInputPhoneNumber,
    AppSelectField,
    AppInputEmail: () => import(/* webpackChunkName: "app-input-email" */ '@/components/AppInputEmail.vue'),
    AppInputRfc: () => import(/* webpackChunkName: "app-input-rfc" */ '@/components/AppInputRfc.vue'),
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
  },
  data() {
    return {
      isLoading: false,
      projectOptions: arrayToOptions(projectArr),
      multiUserOptions: multiUserArr,
    };
  },
  computed: {
    ...mapState({
      tradeName: state => state.users.company.tradeName,
      companyName: state => state.users.company.name,
      accountNumber: state => state.users.company.accountNumber,
      projectName: state => state.users.company.projectName,
      email: state => state.users.email,
      multiUser: state => state.users.company.multiUser,
      name: state => state.users.name,
      rfc: state => state.users.company.rfc,
      userId: state => state.users.userId,
      oldRfc: state => state.users.company.oldRfc,
      employerRegistration: state => state.users.company.employerRegistration,
      phoneNumber: state => state.users.phoneNumber,
    }),
    filteredOptions() {
      const { level } = this.roleOptions.find(role => role.value === this.signedRole);
      const options = this.roleOptions.filter(role => role.level <= level);

      return options;
    },
  },
  async beforeMount() {
    this.loading = true;
    this.setValues(this.$route.params.user);
    this.loading = false;
    this.loaded = true;
  },
  methods: {
    ...mapMutations({
      setUserValue: 'users/setValue',
      setCompanyValue: 'users/setCompanyValue',
    }),
    ...mapActions({ updateUser: 'users/update' }),
    onChangeCompany(event) {
      const { name: accessor, value: plainValue } = event.target;

      const value = plainValue.split(' ').map(upperFirst).join(' ');

      this.setCompanyValue({ accessor, value });
    },
    onChange(event) {
      const { name: accessor, value } = event.target;
      this.setUserValue({ accessor, value });
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        await this.updateUser();
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Datos Actualizados',
        });
        this.$emit('saved');
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: error.message,
        });
        this.isLoading = false;
      }
    },
    setValues(userRow) {
      if (userRow) {
        const {
          rfc,
          companyName,
          tradeName,
          accountNumber,
          projectName,
          email,
          name,
          userId,
          employerRegistration,
          phoneNumber,
          multiUser,
        } = userRow;

        this.$store.commit('users/setValues', {
          name,
          email,
          userId,
          phoneNumber,
          company: {
            rfc,
            name: companyName,
            tradeName,
            accountNumber,
            projectName,
            oldRfc: rfc,
            employerRegistration,
            multiUser,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
form {
  flex-direction: column;
  margin: auto;
}

.submit-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.is-checkradio[type="checkbox"] + label::after,
.is-checkradio[type="checkbox"] + label:after {
  width: 0.4rem;
  height: .95rem;
  top: 0.405rem;
  left: 0.6rem;
}

.is-checkradio[type="radio"] + label::before,
.is-checkradio[type="radio"] + label:before,
.is-checkradio[type="checkbox"] + label::before,
.is-checkradio[type="checkbox"] + label:before {
  top: unset;
}

@media screen and (min-width: 769px) {
  form {
    max-width: 750px;
  }
}
</style>

<style lang="scss">
.new-user {
  .button.is-text,
  .button.is-text:hover,
  .button.is-text:focus {
    background: none;
    color: $primary;
  }
}
</style>
